export function trimSupplierCode(supplierCode: string): string {
    if (supplierCode.length > 5) {
      const trimmedCode = supplierCode.substring(2);
      return trimmedCode.length > 5 ? trimmedCode.substring(0, 5) : trimmedCode;
    }
    return supplierCode;
  }

export function getNamcIdForName(namcName: string): string {
    return namcName === 'TMMK' ? '01' :
         namcName === 'TMMI' ? '02' :
         namcName === 'TMMTX' ? '03' :
         namcName === 'TMMS' ? '04' :
         namcName === 'TMMBC' ? '20' :
         namcName === 'TMMGT' ? '25' :
         namcName === 'MTM' ? '26' : '';
  }
  export function getNamcIdForNameInt(namcName: string): number {
    return namcName === 'TMMK' ? 1 :
         namcName === 'TMMI' ? 2 :
         namcName === 'TMMTX' ? 3 :
         namcName === 'TMMS' ? 4 :
         namcName === 'TMMBC' ? 5 :
         namcName === 'TMMGT' ? 25 :
         namcName === 'MTM' ? 26 : 0;
  }

  export function getTodayDate(): string {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}T00:00:00`;
  }